import React from 'react';
import { paths } from 'routes/paths';
import RouteAdmin, { Flow } from 'screens/Applications&WorkOrders/RouteAdmin';
import { OperationType } from 'components/RecordsListView/constants';
import WorkOrders from 'screens/Applications&WorkOrders/WorkOrders';
import ExportWorkOrderPdf from 'screens/Applications&WorkOrders/WorkOrders/ExportWorkOrderPdf';
import { ROLES } from 'utilities/permissions';

const navRoutes = [
  {
    id: 'workOrders',
    key: 'workOrders',
    path: paths.workOrders,
    label: 'Work Orders',
    exact: true,
    secure: true,
    component: WorkOrders
  }
];
const allRoutes = [
  ...navRoutes,
  {
    id: 'workOrdersCreate',
    key: 'workOrdersCreate',
    path: `${paths.workOrders}/create`,
    exact: true,
    secure: true,
    component: () => (
      <RouteAdmin flow={Flow.CREATE} operationType={OperationType.WORK_ORDER} />
    )
  },
  {
    id: 'workOrdersEdit',
    key: 'workOrdersEdit',
    path: `${paths.workOrders}/:id/edit`,
    exact: true,
    secure: true,
    component: () => (
      <RouteAdmin flow={Flow.EDIT} operationType={OperationType.WORK_ORDER} />
    )
  },
  {
    id: 'workOrdersExport',
    key: 'workOrdersExport',
    path: `${paths.workOrders}/export/:workOrderId`,
    exact: true,
    secure: true,
    component: ExportWorkOrderPdf,
    minPermissions: {
      minAllowedRole: ROLES.VIEW_ONLY
    }
  }
];

export default { navRoutes, allRoutes };
